const customCheckoutWrappers = (): HTMLElement[] => [
  ...(<NodeListOf<HTMLElement>>(
    document.querySelectorAll(".js-bambora-custom-checkout")
  )),
];

const initCheckoutWrapper = (checkoutWrapper: HTMLElement): void => {
  // @ts-ignore
  const customCheckout = globalThis.customcheckout();

  // Listen to complete events.
  // @ts-ignore
  customCheckout.on("complete", (event) => {
    if (event.complete === false) {
      return;
    }

    customCheckout.createToken(
      (result: {
        error: {
          type: string;
          message: string;
        };
        code: number;
        token: string;
      }) => {
        if (result.error) {
          if (result.error.type === "TokenizationValidationFailed") {
            return;
          }

          window.alert(result.error.message);
          throw new Error(JSON.stringify(result.error));
        }

        if (result.code > 299 || !result.token) {
          window.alert("An unknown error occurred processing your card.");
          throw new Error("Unexpected response while creating card token.");
        }

        (<HTMLInputElement>(
          checkoutWrapper.querySelector(".js-bambora-custom-checkout-token")
        )).value = result.token;
      }
    );
  });

  // Mount card number field.
  const cardNumber = customCheckout.create("card-number", {
    placeholder: "Card Number",
    style: {
      base: {
        paddingTop: "15px",
        paddingBottom: "15px",
        fontSize: "16px",
      },
    },
  });

  cardNumber.mount(".js-bambora-custom-checkout-card-number");

  // Mount CVV field.
  const cvv = customCheckout.create("cvv", {
    placeholder: "CVV",
    style: {
      base: {
        paddingTop: "15px",
        paddingBottom: "15px",
        fontSize: "16px",
      },
    },
  });

  cvv.mount(".js-bambora-custom-checkout-cvv");

  // Mount expiry field.
  const expiry = customCheckout.create("expiry", {
    placeholder: "MM / YY",
    style: {
      base: {
        paddingTop: "15px",
        paddingBottom: "15px",
        fontSize: "16px",
      },
    },
  });

  expiry.mount(".js-bambora-custom-checkout-expiry");
};

const initCheckoutWrappers = (): void =>
  customCheckoutWrappers().forEach(initCheckoutWrapper);

window.addEventListener("load", initCheckoutWrappers);
